<craft-notification-item *ngFor="let item of list$ | async" [item]="item" (close)="close(item)" (action)="action($event)"></craft-notification-item>
